import { HHTypography } from '@hinge-health/react-component-library';
import { FunctionComponent } from 'react';
import { usePartnershipById } from '../../hooks/partnership-hook';
import { IRevenueShare } from '../../utils/discount-utils';

export interface RevenueShareLevelDisplayProps {
  revenueShare: IRevenueShare;
}

const RevenueShareLevelDisplay: FunctionComponent<
  RevenueShareLevelDisplayProps
> = ({ revenueShare }): JSX.Element => {
  // ACCOUNTS-AND-PLAN-MIGRATION: partnershipId/clientId are client/partnership-scoped, not resolvable via contract_id — will be addressed by the Accounts & Plan migration.
  const partnership = usePartnershipById(revenueShare.partnershipId);

  const label = revenueShare.clientId
    ? 'Client level'
    : `From ${partnership?.name || 'Unknown'} Partnership`;

  return <HHTypography hhVariant="inherit">{label}</HHTypography>;
};

export default RevenueShareLevelDisplay;
